import { render, staticRenderFns } from "./addSection.vue?vue&type=template&id=497318b3&scoped=true&"
import script from "./addSection.vue?vue&type=script&lang=js&"
export * from "./addSection.vue?vue&type=script&lang=js&"
import style0 from "./addSection.vue?vue&type=style&index=0&id=497318b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497318b3",
  null
  
)

export default component.exports